<template>
  <div>
    <template v-for="channel in channelOptions">
      <v-btn
        :key="`channel_${channel.fullValue}`"
        depressed
        :outline="value != channel.fullValue"
        :color="value == channel.fullValue ? 'primary' : 'grey'"
        class="ma-0 mr-1 mb-1"
        @click="onchange(channel.fullValue)"
        >{{ $t(channel.text) }}</v-btn
      >
    </template>
  </div>
</template>

<script>
export default {
  filters: {
    capitalize(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    channels: {
      type: [Array],
      default: null
    }
  },
  computed: {
    channelOptions() {
      const options = [
        {
          value: 'all',
          fullValue: 'all',
          text: 'All',
          icon: ''
        },
        ...this.socialChannelOptions
      ]
      return this.channels
        ? options.filter((option) => {
            return this.channels.includes(option.fullValue)
          })
        : options
    }
  },
  methods: {
    capitalize(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    },
    onchange(value) {
      this.$emit('input', value)
      this.$emit('changeChannel', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/SelectChannel.vue